import { Component, OnInit, Input } from '@angular/core';
import { Course } from 'lms-api';
import { UserCourseDataService } from 'lms-api';

@Component({
  selector: 'app-course-tag-bar',
  templateUrl: './course-tag-bar.component.html',
  styleUrls: ['./course-tag-bar.component.scss']
})
export class CourseTagBarComponent implements OnInit {
  @Input() course: Course;

  constructor(
    public ucdService: UserCourseDataService
  ) { }

  ngOnInit() {
  }

  toggleFavorite() {
    this.ucdService.FavoriteCourse(this.course.netforum_course_id);
    return false;
  }

}
